module.exports = __webpack_public_path__ + "img/Full Force Galesburg.5e905626.jpg";